<template>
  <div class="flex flex-row gap-3 p-2">
    <div class="flex flex-row gap-3">
      <button
        class="flex items-center justify-center rounded-full bg-white w-12 h-12 !shadow disabled:!bg-gray-200"
        type="button"
        :disabled="currentIndex === 0"
        @click="moveIndexBy(-1)">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </button>
      <button
        class="flex items-center justify-center rounded-full bg-white w-12 h-12 !shadow disabled:!bg-gray-200"
        type="button"
        :disabled="currentIndex === schedules.length - 1"
        @click="moveIndexBy(1)">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M9 5l7 7-7 7"
          />
        </svg>
      </button>
    </div>
    <ScheduleDateRangeDisplay
      :schedules="schedules"
      :currentIndex="currentIndex"
    />
  </div>
</template>

<script>
import ScheduleDateRangeDisplay from './ScheduleDateRangeDisplay.vue'

export default {
  components: {
    ScheduleDateRangeDisplay,
  },
  props: {
    schedules: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentIndex: undefined,
    }
  },
  methods: {
    moveIndexBy(offset) {
      this.currentIndex += offset
      if (this.currentIndex < 0) {
        this.currentIndex = 0
      }
      if (this.currentIndex >= this.schedules.length) {
        this.currentIndex = this.schedules.length - 1
      }

      this.$emit('select', this.currentIndex, this.schedules[this.currentIndex].dbId)
    },
  },
  mounted() {
    if (this.schedules.length !== undefined) {
      this.currentIndex = this.schedules.length - 1
    }
  },
  watch: {
    schedules(newValue) {
      this.currentIndex = newValue.length - 1
    },
  },
}
</script>
